/**
 * Préférences sonores Admin — localStorage uniquement.
 * Clés commerçant : notifications_{id}_*
 * Clés globales / Super Admin : notifications_*
 */

export function getNotificationSoundStoragePrefix(commercantId) {
  return commercantId ? `notifications_${commercantId}_` : 'notifications_';
}

export function readNotificationSoundPrefs(commercantId = null) {
  if (typeof localStorage === 'undefined') {
    return {
      enabled: true,
      volume: 0.7,
      repeatMode: 'unique',
      repeatInterval: 3,
    };
  }

  const keyPrefix = getNotificationSoundStoragePrefix(commercantId);
  const oldRepeatUntilAction = localStorage.getItem(`${keyPrefix}repeatUntilAction`) === 'true';
  const storedMode = localStorage.getItem(`${keyPrefix}repeatMode`);
  const repeatMode = oldRepeatUntilAction ? 'repeat' : (storedMode || 'unique');
  const volume = parseFloat(localStorage.getItem(`${keyPrefix}volume`) || '0.7');

  return {
    enabled: localStorage.getItem(`${keyPrefix}enabled`) !== 'false',
    volume: Number.isFinite(volume) ? Math.max(0, Math.min(1, volume)) : 0.7,
    repeatMode: repeatMode === 'repeat' ? 'repeat' : 'unique',
    repeatInterval: parseFloat(localStorage.getItem(`${keyPrefix}repeatInterval`) || '3') || 3,
  };
}

export function persistNotificationSoundPref(commercantId, key, value) {
  if (typeof localStorage === 'undefined') return;
  const keyPrefix = getNotificationSoundStoragePrefix(commercantId);
  const serialized = String(value);

  if (key === 'enabled') {
    localStorage.setItem(`${keyPrefix}enabled`, value ? 'true' : 'false');
  } else if (key === 'volume') {
    localStorage.setItem(`${keyPrefix}volume`, serialized);
  } else if (key === 'repeatMode') {
    localStorage.setItem(`${keyPrefix}repeatMode`, serialized);
    localStorage.removeItem(`${keyPrefix}repeatUntilAction`);
  } else if (key === 'repeatInterval') {
    localStorage.setItem(`${keyPrefix}repeatInterval`, serialized);
  }

  if (commercantId) {
    if (key === 'enabled') {
      localStorage.setItem('notifications_enabled', value ? 'true' : 'false');
    } else if (key === 'volume') {
      localStorage.setItem('notifications_volume', serialized);
    } else if (key === 'repeatMode') {
      localStorage.setItem('notifications_repeatMode', serialized);
      localStorage.removeItem('notifications_repeatUntilAction');
    } else if (key === 'repeatInterval') {
      localStorage.setItem('notifications_repeatInterval', serialized);
    }
  }
}

/**
 * Playback métier — même pipeline que Tester (audioService.play / startRepeat).
 * Son OFF = aucun playback.
 */
export function playNotificationFromPrefs(audioService, commercantId = null) {
  const prefs = readNotificationSoundPrefs(commercantId);
  if (!prefs.enabled) {
    return { played: false, reason: 'disabled' };
  }

  audioService.setEnabled(true);
  audioService.setVolume(prefs.volume);

  if (prefs.repeatMode === 'repeat') {
    audioService.startRepeat(prefs.repeatInterval * 1000);
  } else {
    audioService.play();
  }

  return { played: true, volume: prefs.volume, repeatMode: prefs.repeatMode };
}
